import { CodingExamExaminerData } from '../../../store/workspace/types';

export type CodingScore = CodingExamExaminerData['scores'][number];

export type CodingMetricKey =
    | 'test_coverage'
    | 'execution_time'
    | 'space_complexity'
    | 'time_complexity'
    | 'readability'
    | 'duplication'
    | 'efficiency'
    | 'complexity'
    | 'maintainability';

export interface CodingMetric {
    key: CodingMetricKey;
    title: string;
};

/**
 * The metrics a coding answer is graded on, grouped exactly as the table header
 * and the mobile cards present them.
 */
export const CODING_METRIC_GROUPS: { title: string; metrics: CodingMetric[] }[] = [
    {
        title: 'Test Cases',
        metrics: [
            { key: 'test_coverage', title: 'Coverage' },
            { key: 'execution_time', title: 'Time' },
        ],
    },
    {
        title: 'Complexity',
        metrics: [
            { key: 'space_complexity', title: 'Space' },
            { key: 'time_complexity', title: 'Time' },
        ],
    },
    {
        title: 'Code Quality',
        metrics: [
            { key: 'readability', title: 'Readability' },
            { key: 'duplication', title: 'Duplication' },
            { key: 'efficiency', title: 'Efficiency' },
            { key: 'complexity', title: 'Complexity' },
            { key: 'maintainability', title: 'Maintainability' },
        ],
    },
];

/**
 * Some metrics are plain numbers, others are objects carrying their own
 * `score`. Returns `undefined` when the answer has not been graded.
 */
export const codingScoreOf = (score: CodingScore | undefined, key: CodingMetricKey) => {
    if (!score) return undefined;

    const value = score[key];
    return typeof value === 'number' ? value : value.score;
};
